var exports = {
  "T": "x93eb46d8--ec383a--tag",
};

module.exports = exports;
